import { eventBus } from '@atc/cai-event-bus';
import { WALLET_UPDATE_PAYMENTS_INFO_REQUEST } from 'wallet-manager';
const updatePaymentsInfo = () => (payload, userInputData) => async (dispatch, getState) => {
  const {
    payments: {
      myWallet: {
        configs
      } = {},
      interactions: {
        budgetSummaryType
      } = {},
      paymentOption
    } = {}
  } = getState();
  eventBus.emit(WALLET_UPDATE_PAYMENTS_INFO_REQUEST, {
    payload,
    myWalletConfig: configs,
    paymentOption,
    budgetSummaryType,
    // extra data set for tagging after payments info is updated
    userInputData
  });
};
export default updatePaymentsInfo;